<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    placeholder="Viloyatlar"
                    v-model="form.region_id"
                    @change="onRegionChange"
                    :loading="regionsLoading"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    placeholder="Tuman/Shahar"
                    style="width: 100%"
                    size="large"
                    v-model="form.district_id"
                    @change="onDistrictChange"
                    :loading="districtsLoading"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahallani tanlang" prop="quarter_id">
                <el-select
                    placeholder="Mahalla"
                    style="width: 100%"
                    size="large"
                    v-model="form.quarter_id"
                    :loading="quartersLoading"
                    :disabled="!form.district_id"
                >
                  <el-option
                      v-for="quarter in quarters"
                      :key="quarter.id"
                      :value="quarter.id"
                      :label="quarter.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Sarlavha" prop="title">
                <el-input
                    placeholder="Malumot kiriting"
                    size="large"
                    class="form-input"
                    v-model="form.title"
                    type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tashkilot turi" prop="organization_type">
                <el-select
                    placeholder="Tashkilotlar turi"
                    style="width: 100%"
                    size="large"
                    v-model="form.organization_type"
                >
                  <el-option
                      v-for="ty in types"
                      :key="ty.value"
                      :value="ty.value"
                      :label="ty.label"
                  />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Inn" prop="inn">
                <el-input
                    size="large"
                    placeholder="Malumot kiriting"
                    class="form-input"
                    v-model="form.inn"
                    type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tashkilot kodi" prop="org_code">
                <el-input
                    size="large"
                    placeholder="Tashkilot kodi kiriting"
                    class="form-input"
                    v-model="form.org_code"
                    type="number"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="form.id">
              <el-form-item label="Holati" prop="status">
                <el-checkbox
                    @change="onChangeStatus"
                    size="large"
                    border
                    v-model="status"
                    label="Faol"
                />
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElMessage, ElNotification} from "element-plus";

export default {
  name: "OrganizationForm",
  data() {
    return {
      loading: false,
      is_editing: false,
      regionsLoading: false,
      districtsLoading: false,
      quartersLoading: false,
      regions: [],
      districts: [],
      quarters: [],
      types: [
        {value: "KINDERGARDEN", label: "Bog'cha"},
        {value: "SCHOOL", label: "Maktab"},
        {value: "HEALTHCARE", label: "Sog'liqni saqlash"},
        {value: "HIGHERSCHOOL", label: "Oliy ta'lim"},
        {value: "MUSIC", label: "Musiqa"},
        {value: "SPORT", label: "Sport"},
        {value: "CULTURE", label: "Aholi dam olish maskanlari"},
        {value: "OTHEREDUCATIONS", label: "Boshqa"},
      ],
      form: {
        title: null,
        organization_type: null,
        district_id: null,
        region_id: null,
        quarter_id: null,
        inn: null,
        org_code: null,
      },
      status: false,
      rules: {
        title: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        organization_type: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        region_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        district_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        quarter_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        inn: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      },
    };
  },
  methods: {
    onChangeStatus() {
      this.$http
          .patch(`/api/v1/organizations/status-toggle/${this.form.id}`)
          .then(() => {
            ElMessage.success("Holati o'zgartirildi");
            this.getOrg(this.form.id);
          })
          .catch(() => {
            ElMessage.error("Xatolik yuz berdi");
          });
    },
    onRegionChange() {
      this.form.district_id = null;
      this.form.quarter_id = null;
      this.districts = [];
      this.quarters = [];
      this.getDistricts();
    },
    onDistrictChange() {
      this.form.quarter_id = null;
      this.quarters = [];
      this.getQuarters();
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;

          const formData = {
            ...this.form,
          };

          if (this.form.id) {
            http = this.$http.put(
                `/api/v1/organizations/${this.form.id}`,
                formData
            );
          } else {
            http = this.$http.post("/api/v1/organizations/", formData);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch(() => {
            ElMessage.error("Viloyatlarni yuklashda xatolik");
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.form.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch(() => {
            ElMessage.error("Tumanlarni yuklashda xatolik");
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getQuarters() {
      if (!this.form.region_id || !this.form.district_id) {
        return;
      }
      
      this.quartersLoading = true;
      this.$http
          .get("/api/v1/quarters", {
            params: {
              region_id: this.form.region_id,
              district_id: this.form.district_id,
            },
          })
          .then(({data}) => {
            this.quarters = data.quarters || data;
          })
          .catch(() => {
            ElMessage.error("Mahallalarni yuklashda xatolik");
          })
          .finally(() => {
            this.quartersLoading = false;
          });
    },
    getOrg(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/organizations/${id}`)
          .then(({data}) => {
            this.form = data;
            this.status = data.status === 'ACTIVE';
            this.getDistrict(this.form.district_id);
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/districts/${id}`)
          .then(({data}) => {
            this.districts.push(data);
            this.form.region_id = data.region_id;
            this.getDistricts();
            
            if (this.form.quarter_id) {
              this.getQuarters();
            }
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.is_editing = true;
      this.getOrg(this.$route.query.id);
    }
    this.getRegions();
  },
};
</script>

<style scoped></style>